import * as Yup from 'yup';

import i18n from '~/translations';
import { VALIDATION_MESSAGE } from '~/utils/validators';

export const cancelSubscriptionFeedbackSchema = Yup.object({
  other: Yup.string().max(1000, VALIDATION_MESSAGE.MAX_LENGTH),
  reasons: Yup.array(Yup.string().required()).min(
    1,
    i18n.t('cancelSubscriptionModal.choiceRequired', 'You must select at least one reason.'),
  ),
});

export type CancelSubscriptionFeedbackDto = Yup.InferType<typeof cancelSubscriptionFeedbackSchema>;
